// @flow

import * as React from 'react';
import {Helmet} from 'react-helmet-async';
import {useArticle, usePrefs} from 'docs/data';

import StripeShellSplash from 'docs/images/stripe-shell/stripe-shell-splash.png';

export const OpenGraphMetaTags = () => {
  const {article} = useArticle();
  const {getPref} = usePrefs();

  let articleTitle = article.metadata.title;
  let articleSubtitle = article.metadata.subtitle;
  let imageUrl = article.openGraphImageUrl;

  // This is a one-off override to get a different social card to
  // render when `stripe.sh` linked as it redirects to
  // `/docs?shell=true`
  if (article.path === '/docs' && !!getPref('shell')) {
    articleTitle = 'Stripe Shell';
    articleSubtitle = 'Use the CLI directly from Stripe docs';
    imageUrl = StripeShellSplash;
  }

  if (!imageUrl) {
    return null;
  }

  return (
    <Helmet>
      <meta property="og:type" content="website" />
      <meta property="og:title" content={articleTitle} />
      {articleSubtitle && (
        <meta property="og:description" content={articleSubtitle} />
      )}
      <meta property="og:image" content={imageUrl} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={articleTitle} />
      {articleSubtitle && (
        <meta name="twitter:description" content={articleSubtitle} />
      )}
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
};
